import { useEffect, useState } from "react";
import EntityEditor from "../components/EntityEditor";
import { adminApi } from "../api";

const FIELDS = [
  { key: "name", label: "Nome", required: true },
  { key: "slug", label: "Slug", required: true },
  {
    key: "stars",
    label: "Stelle",
    type: "select",
    options: [
      { value: 3, label: "3 stelle" },
      { value: 4, label: "4 stelle" },
      { value: 5, label: "5 stelle" },
    ],
  },
  { key: "area", label: "Zona" },
  { key: "opening", label: "Apertura (es. Marzo 2026, Q4 2027)" },
  { key: "description", label: "Descrizione", textarea: true, rows: 5 },
  { key: "image", label: "Rendering / foto (opzionale)", type: "image" },
  { key: "logo", label: "Logo progetto (SVG/PNG trasparente)", type: "image" },
  {
    key: "project_url",
    label: "Link 'Il progetto' (URL esterno o /percorso interno · opzionale)",
    placeholder: "https://… oppure /hotel/bloom",
  },
  { key: "order", label: "Ordine", type: "number" },
  {
    key: "lat",
    label: "Latitudine (per mappa · es. 45.4642)",
    type: "number",
    step: "any",
    nullable: true,
    placeholder: "vuoto = usa default seed",
  },
  {
    key: "lng",
    label: "Longitudine (per mappa · es. 9.1899)",
    type: "number",
    step: "any",
    nullable: true,
    placeholder: "vuoto = usa default seed",
  },
  { key: "published", label: "Pubblicato", type: "checkbox" },
];

const INITIAL = {
  slug: "",
  name: "",
  stars: 4,
  area: "",
  opening: "",
  description: "",
  image: "",
  logo: "",
  project_url: "",
  order: 999,
  lat: null,
  lng: null,
  published: true,
};

export default function AdminOpenings() {
  const [items, setItems] = useState([]);
  const load = () =>
    adminApi.get("/admin/openings").then((r) => setItems(r.data));

  useEffect(() => {
    load();
  }, []);

  return (
    <EntityEditor
      title="Nuove Aperture"
      subtitle="Progetti in fase di realizzazione o prossima apertura."
      endpoint="/admin/openings"
      fields={FIELDS}
      items={items}
      initial={INITIAL}
      onReload={load}
      renderRow={(item) => (
        <div>
          <div className="font-display text-lg">{item.name}</div>
          <div className="mt-1 text-xs text-white/50 font-mono uppercase tracking-[0.15em]">
            {"★".repeat(item.stars)} · {item.area} · Apertura {item.opening}
          </div>
        </div>
      )}
    />
  );
}
